import { createContext } from "react";

/**
 * Whether `ImageSelectionModal` offers its Brand filter. Context rather than
 * a prop because Native Delivery mounts the modal from many fields several
 * layers deep; its layout and journey composer turn this on, and every other
 * host of the modal leaves it off.
 */
export const ImagePickerBrandFilterContext = createContext(false);
